import { render, staticRenderFns } from "./SpaceMembers.vue?vue&type=template&id=65636f70&"
import script from "./SpaceMembers.vue?vue&type=script&lang=ts&"
export * from "./SpaceMembers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports